/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_MODELS_REQUEST, REZET_MODELS_REQUEST } from '../actions/modelsAction';

const initialState = {
  models: null
};

const modelsReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_MODELS_REQUEST:
    case REZET_MODELS_REQUEST: {
      const { models } = action.payload;
      return produce(state, (draft) => {
        draft.models = models;
      });
    }

    default: {
      return state;
    }
  }
};

export default modelsReducer;
